import { render, staticRenderFns } from "./areaSelectNotDetails.vue?vue&type=template&id=665b6fbf"
import script from "./areaSelectNotDetails.vue?vue&type=script&lang=js"
export * from "./areaSelectNotDetails.vue?vue&type=script&lang=js"
import style0 from "./areaSelectNotDetails.vue?vue&type=style&index=0&id=665b6fbf&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports